import type { ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { FaqSection, type FaqItem } from "./PageFaq";

export function InfoLayout({
  title,
  children,
  faq,
  showFaq = true,
}: {
  title: string;
  children: ReactNode;
  faq?: FaqItem[];
  showFaq?: boolean;
}) {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:px-8">
        <h1 className="font-display text-3xl font-extrabold tracking-tight text-foreground sm:text-4xl">
          {title}
        </h1>
        <div className="mt-6 space-y-5 text-[15px] leading-relaxed text-foreground/80 [&_h2]:font-display [&_h2]:text-xl [&_h2]:font-extrabold [&_h2]:text-foreground [&_h2]:mt-8 [&_h3]:font-display [&_h3]:text-lg [&_h3]:font-bold [&_h3]:text-foreground [&_h3]:mt-6 [&_a]:text-primary [&_a]:underline [&_.not-prose_a]:text-inherit [&_.not-prose_a]:no-underline">
          {children}
        </div>
        {showFaq && <FaqSection items={faq} className="!px-0" />}
      </main>
      <Footer />
    </div>
  );
}
